import { fulfilled, failed, pending } from "lib/promiseMiddlewareTypes";
import initialState from "store/initialState";
import { GET_ALIGNMENT_RESULTS } from "actions/alignmentResults";

const alignmentResults = (state = initialState.alignmentResults, action: any) => {
  switch (action.type) {
    case failed(GET_ALIGNMENT_RESULTS):
    case pending(GET_ALIGNMENT_RESULTS):
      return [];
    case fulfilled(GET_ALIGNMENT_RESULTS):
      return action.payload;
    default:
      return state;
  }
};

export default alignmentResults;
